{
  "Billing": "Rozliczenia",
  "Return to App": "Wróć do aplikacji",
  "Home": "Strona główna",
  "Calendar": "Kalendarz",
  "Dashboard": "Panel",
  "ATP": "ATP",
  "Subscriptions": "Subskrypcje",
  "Payment Methods": "Metody płatności",
  "Purchases": "Zakupy",
  "View Profile": "Wyświetl profil",
  "TrainingPeaks Athlete Since": "Zawodnik TrainingPeaks od",
  "TrainingPeaks Coach Since": "Trener TrainingPeaks od",
  "Invoice": "Faktura",
  "No results": "Brak wyników",
  "qtr": "kw.",
  "Show all transactions": "Pokaż wszystkie transakcje",
  "No transactions found": "Nie znaleziono transakcji",
  "Loading purchases": "Ładowanie zakupów",
  "Error loading purchases": "Błąd ładowania zakupów",
  "Active": "Aktywna",
  "Inactive": "Nieaktywna",
  "Cancelled": "Anulowana",
  "PastDue": "Zaległa",
  "Trialing": "Okres próbny",
  "Next Renewal": "Następne odnowienie",
  "Manage": "Zarządzaj",
  "plus tax": "plus podatek",
  "No subscriptions found": "Nie znaleziono subskrypcji",
  "No purchases found": "Nie znaleziono zakupów",
  "Show all": "Pokaż wszystko",
  "Show less": "Pokaż mniej",
  "Date": "Data",
  "Description": "Opis",
  "Amount": "Kwota",
  "Status": "Status",
  "Paid": "Opłacona",
  "Failed": "Nieudana",
  "Pending": "Oczekująca",
  "Refunded": "Zwrócona",
  "Loading": "Ładowanie",
  "Error loading data": "Błąd ładowania danych",
  "month": "miesiąc",
  "year": "rok",
  "quarter": "kwartał",
  "mo": "mies.",
  "yr": "rok",
  "Default": "Domyślna",
  "Expires": "Wygasa",
  "Card ending in": "Karta kończąca się na",
  "Flexible planning to fit your life": "Elastyczne planowanie dopasowane do Twojego życia",
  "Actionable Insights to keep you on track": "Praktyczne wskazówki, które pomogą Ci pozostać na właściwej drodze",
  "Strength training to avoid injury": "Trening siłowy, aby uniknąć kontuzji",
  "Ride the world inside on Virtual": "Odkrywaj świat w domu z Virtual",
  "Any sport, any device, any time": "Każdy sport, każde urządzenie, o każdej porze",
  "Annual": "Rocznie",
  "Monthly": "Miesięcznie",
  "Billed USD $134.99/yr": "Rozliczane: 134,99 USD/rok",
  "Most Popular": "Najpopularniejsze",
  "$19.95 $11.25/mo": "19,95 $ 11,25 $/mies.",
  "$19.95/mo": "19,95 $/mies.",
  "Checkout": "Przejdź do płatności",
  "Progress starts with Premium.": "Postępy zaczynają się z Premium.",
  "Add Card": "Dodaj kartę",
  "Close": "Zamknij",
  "Primary": "Główna",
  "Delete": "Usuń",
  "Make Primary": "Ustaw jako główną",
  "Error loading payment methods": "Błąd ładowania metod płatności",
  "Your card has expired. Please add a new card.": "Twoja karta wygasła. Dodaj nową kartę.",
  "Unable to load payment form. Please try again later.": "Nie można załadować formularza płatności. Spróbuj ponownie później.",
  "A temporary $1.00 charge will be made to validate your payment method. This charge is automatically refunded.": "Aby zweryfikować metodę płatności, zostanie pobrana tymczasowa opłata w wysokości 1,00 USD. Opłata zostanie automatycznie zwrócona.",
  "Payment method added successfully": "Metoda płatności została dodana",
  "Default payment method updated": "Domyślna metoda płatności została zaktualizowana",
  "Payment method deleted": "Metoda płatności została usunięta",
  "Failed to set default payment method": "Nie udało się ustawić domyślnej metody płatności",
  "Failed to update default payment method": "Nie udało się zaktualizować domyślnej metody płatności",
  "Failed to delete payment method": "Nie udało się usunąć metody płatności",
  "Maximize Your Premium Subscription \n Before You Go!": "Wykorzystaj w pełni subskrypcję Premium,\nzanim odejdziesz!",
  "TrainingPeaks Virtual": "TrainingPeaks Virtual",
  "Ride inside with our virtual cycling experience": "Jeździj w domu dzięki naszym wirtualnym doświadczeniom kolarskim",
  "Strength Builder": "Kreator treningów siłowych",
  "Create and save strength workouts": "Twórz i zapisuj treningi siłowe",
  "Metrics Charts": "Wykresy metryk",
  "Analyze metrics from your synced devices": "Analizuj dane z zsynchronizowanych urządzeń",
  "Performance Metrics": "Metryki wydajności",
  "Fitness (CTL), Fatigue (ATL) and Form (TSB)": "Sprawność (CTL), zmęczenie (ATL) i forma (TSB)",
  "Peak Performances": "Najlepsze wyniki",
  "Track and compare your best efforts": "Śledź i porównuj swoje najlepsze wysiłki",
  "NEW!": "NOWOŚĆ!",
  "Cancel Subscription": "Anuluj subskrypcję",
  "Renew Subscription": "Odnów subskrypcję",
  "Complimentary": "Bezpłatna",
  "Your complimentary access is active through": "Twój bezpłatny dostęp jest aktywny do",
  "Keep your goals in sight -- renew Premium to stay on track for race day.": "Miej swoje cele na oku - odnów Premium, aby pozostać na właściwej drodze do dnia zawodów.",
  "Renew": "Odnów",
  "Auto-Renew Off": "Automatyczne odnowienie wyłączone",
  "Access through": "Dostęp do",
  "Turn Auto-Renew On": "Włącz automatyczne odnowienie",
  "Are you sure you want to cancel coaching?": "Czy na pewno chcesz anulować coaching?",
  "Reaching your goals takes the right fit. Before you cancel, let us know if you need to pause, adjust your package level, or speak directly with a Coach Match Specialist.": "Osiągnięcie celów wymaga odpowiedniego dopasowania. Zanim anulujesz, daj nam znać, czy chcesz wstrzymać, zmienić poziom pakietu lub porozmawiać bezpośrednio ze specjalistą Coach Match.",
  "Pause, Adjust, or Contact Support": "Wstrzymaj, dostosuj lub skontaktuj się z pomocą techniczną",
  "Yes, Cancel": "Tak, anuluj",
  "Keep My Coaching": "Zachowaj mój coaching",
  "Coach Match subscription: Pause, Adjust, or Speak with Specialist": "Subskrypcja Coach Match: Wstrzymaj, dostosuj lub porozmawiaj ze specjalistą",
  "Hi Coach Match Team,\n\nI am reaching out regarding my coaching membership. Before deciding whether to cancel, I would like to [pause my membership / adjust my package level / speak with a Coach Match Specialist].\n\nMy account email is: [Your Email]\n\nThanks!": "Witam zespół Coach Match,\n\nPiszę w sprawie mojego członkostwa coachingowego. Zanim zdecyduję, czy anulować, chciałbym/chciałabym [wstrzymać moje członkostwo / dostosować poziom pakietu / porozmawiać ze specjalistą Coach Match].\n\nMój adres e-mail konta to: [Twój e-mail]\n\nDziękuję!",
  "Before you go...": "Zanim odejdziesz...",
  "What's the reason for canceling?": "Jaki jest powód anulowania?",
  "Price / Financial Reasons": "Cena / Powody finansowe",
  "The subscription cost no longer fits my budget.": "Koszt subskrypcji nie mieści się już w moim budżecie.",
  "Injured / Health Reasons": "Kontuzja / Powody zdrowotne",
  "I'm unable to train due to injury or health.": "Nie mogę trenować z powodu kontuzji lub stanu zdrowia.",
  "Finished Goal Event": "Ukończone wydarzenie docelowe",
  "I completed my target race or event.": "Ukończyłem/am mój docelowy wyścig lub wydarzenie.",
  "Poor Experience / Fit": "Złe doświadczenie / Niedopasowanie",
  "The coaching style or program wasn't the right match.": "Styl coachingu lub program nie był odpowiedni.",
  "Temporary Pause / Restart Later": "Tymczasowa przerwa / Wznowienie później",
  "Life got busy — I'd like to come back when I'm ready.": "Życie stało się intensywne — chciałbym/chciałabym wrócić, gdy będę gotowy/a.",
  "Other": "Inne",
  "Optional: Why?": "Opcjonalnie: Dlaczego?",
  "Continue": "Kontynuuj",
  "Keep Subscription": "Zachowaj subskrypcję"
}
